module.exports = __webpack_public_path__ + "static/media/logo-shadow-64.269763fa.png";